import { motion } from 'framer-motion';
import { X } from 'lucide-react';
import { createPortal } from 'react-dom';

export default function ModalWrapper({
    children,
    onClose,
    backgroundColor,
    title,
    subTitleSection,
    disableHeaderBorder = false,
    className = "",
    showClose = true,
    animationType = "zoom-in", // zoom-in | slide-up
    zIndex = "2147483647",
}) {

    const initialAnimation = {
        "zoom-in": { scale: 0.9, opacity: 0 },
        "slide-up": { y: 50, opacity: 0 },
    }
    const animateAnimation = {
        "zoom-in": { scale: 1, opacity: 1 },
        "slide-up": { y: 0, opacity: 1 },
    }
    const exitAnimation = {
        "zoom-in": { scale: 0.9, opacity: 0 },
        "slide-up": { y: 50, opacity: 0 },
    }

    const modalContent = (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className={`fixed inset-0 z-[${zIndex}] bg-black/70 backdrop-blur-sm flex items-center justify-center p-4`}
            onClick={onClose}
        >
            <motion.div
                layout="size"
                initial={initialAnimation[animationType]}
                animate={animateAnimation[animationType]}
                exit={exitAnimation[animationType]}
                transition={{
                    type: 'spring',
                    damping: 25,
                    stiffness: 300
                }}
                onClick={(e) => e.stopPropagation()}
                className={`
                    ${backgroundColor ? `bg-[${backgroundColor}]` : "bg-[#353530]"}
                    rounded-2xl
                    w-full
                    max-h-[90vh]
                    overflow-y-auto
                    scrollbar-hide
                    ${className.includes("max-w-")
                        ? className
                        : `${className} max-w-lg`
                    }
                `}
            >
                {title && (
                    <div className={`flex flex-col p-4 ${!disableHeaderBorder && "border-b border-[#4a4a4a]"}`}>
                        <div className='flex items-center justify-between'>
                            <h2 className="text-xl font-sora font-semibold text-white">
                                {title}
                            </h2>

                            {showClose && (
                                <button
                                    onClick={onClose}
                                    className="text-gray-400 hover:text-white transition-colors"
                                >
                                    <X className="w-6 h-6" />
                                </button>
                            )}
                        </div>

                        {subTitleSection}
                    </div>
                )}

                {children}
            </motion.div>
        </motion.div>
    );

    return createPortal(modalContent, document.body);
}